import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  EnterpriseSearchService,
  UserService,
  ServiceType,
  ModalOpenerService
} from '@sabstravtech/obtservices/angular';

import { LightningModalTypes } from '../../../core/classes/modal-types.enum';

@Component({
  selector: 'app-product-checkbox',
  templateUrl: './product-checkbox.component.html',
  styleUrls: ['./product-checkbox.component.scss'],
  standalone: false
})
export class ProductCheckboxComponent implements OnInit {
  @Input() service: ServiceType;
  @Input() isPaymentRestrictedDueToNoCard = false;
  @Input() disabled = false;
  @Output() selected: EventEmitter<ServiceType> = new EventEmitter<ServiceType>();
  @Input() disableGroup: boolean = false;
  @Input() comboSelected: boolean = false;
  @Input() isComboButton: boolean = false;
  @Input() ariaLabel: string = null;
  @Input() ariaDescribedBy: string = null;
  isJyrney: boolean = false;
  jyrneyUrl: string = '';

  constructor(
    public userService: UserService,
    public searchService: EnterpriseSearchService,
    public modalService: ModalOpenerService
  ) {}

  async ngOnInit() {
    if (this.service === ServiceType.Cab) {
      await this.handleJyrney();
    }
  }

  async handleJyrney(): Promise<void> {
    // console.warn(`Taxi Service Detected - checking for Jyrney`);
    // now we need to grab all taxi services and check for Jyrney
    const userServices = this.userService.getfullUserDetails().userServices.value;
    // console.log(userServices);

    const haveJyrney = userServices?.CAB?.find((cabService) => {
      return cabService.name.toLowerCase() === 'jyrney';
    })
      ? true
      : false;

    this.isJyrney = haveJyrney;

    // will also need a call to get the url from the service config - may need to expand this depending on how sso is handled.
    const url = haveJyrney ? await this.searchService.getJyrneyUrl() : '';
    this.jyrneyUrl = url;
  }

  onCheckboxClick(): void {
    if (this.isJyrney) {
      // open the jyrney url in a new tab
      window.open(this.jyrneyUrl, '_blank');
      return;
    }

    if (this.disableGroup) {
      return;
    }
    if (this.disabled) {
      if (this.isPaymentRestrictedDueToNoCard) {
        this.modalService.open(LightningModalTypes.CheckPaymentMethod, { centered: true });
      } else {
        this.showDisabledServicePopup();
      }
    } else {
      this.selected.emit(this.service);
    }
  }

  showDisabledServicePopup(): void {
    this.modalService.open(
      LightningModalTypes.DisabledServiceModalComponent,
      { centered: true },
      { service: this.service }
    );
  }
}
